import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const EyeSlash = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.98 8.22A10.48 10.48 0 0 0 1.93 12a10.5 10.5 0 0 0 12.93 7.1M6.23 6.24A10.45 10.45 0 0 1 12 4.5 10.5 10.5 0 0 1 22.06 12a10.52 10.52 0 0 1-4.29 5.77M6.23 6.23 3 3m3.23 3.23 3.65 3.65m7.9 7.9L21 21m-3.23-3.23-3.65-3.65m0 0a3 3 0 1 0-4.24-4.24m4.24 4.24L9.88 9.88"
    />
  </svg>
));
